import React, { Component } from 'react';
import { Input } from 'antd';
import PropTypes from 'prop-types';

/**
 * @component
 * @category Form Page
 * @subcategory LCL/AIR Tab
 * @name NumericCustomInput
 * @description Custom input for accepting only numeric key press
 * <br> <br>
 * **Example**
 * ```js
 *   <NumericCustomInput {...props} />
 * ```
 */
class NumericCustomInput extends Component {
  onChange = (e) => {
    const { value } = e.target;
    const reg = /^-?[0-9]*(\.[0-9]*)?$/;
    if ((!isNaN(value) && reg.test(value)) || value === '') {
      this.props.onChange(value);
    }
  };

  // '.' at the end or only '-' in the input box.
  onBlur = () => {
    const { value, onBlur, onChange } = this.props;
    let valueTemp = value;
    if (value && value.charAt(value.length - 1) === '.') {
      valueTemp = value.slice(0, -1);
    }
    onChange(valueTemp && valueTemp.replace(/0*(\d+)/, '$1'));
    if (onBlur) {
      onBlur();
    }
  };

  onFocus = () => {
    if (this.props.onFocus) this.props.onFocus();
  };

  render() {
    return (
      <Input
        {...this.props}
        onChange={this.onChange}
        onBlur={this.onBlur}
        onFocus={this.onFocus}
        maxLength={25}
        autoComplete="off"
      />
    );
  }
}

NumericCustomInput.propTypes = {
  /**
   * input field value, only numeric key press is allowed
   */
  value: PropTypes.string,
  /**
   * onblur event
   */
  onBlur: PropTypes.func,
  /**
   * onchange event
   */
  onChange: PropTypes.func,
  /**
   * onfocus event
   */
  onFocus: PropTypes.func,
};

export default NumericCustomInput;
